import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FiOnboardingViewerComponent } from "./fi-onboarding-viewer.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { FiAttachmentsModule } from "@fi-app/shared/media-bank/fi-attachments/fi-attachments.module";
import { FiAppTextSharedModule } from "@fi-app/shared/app-text";
import { FiBindHtmlCompileModule } from "@fi-app/shared/fi-directives/bind-html-compile/bind-html-compile.module";
import { FiMatIconCheckboxMenuModule } from "@fi-app/shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module";
import { FiOnboardingEditModule } from "../fi-onboarding-edit/fi-onboarding-edit.module";

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        FiAppTextSharedModule,
        FiAttachmentsModule,
        FiBindHtmlCompileModule,
        FiMatIconCheckboxMenuModule,
        FiOnboardingEditModule,
    ],
    declarations: [
        FiOnboardingViewerComponent,
    ],
    exports: [
        FiOnboardingViewerComponent,
    ],
})
export class FiOnboardingViewerModule {}